/**
 * @file useHeightScaling.js
 * @description Custom hook for calculating viewport height scaling while preserving original width.
 */
import { useState, useEffect } from 'react';

const useHeightScaling = (baseHeight = 1080) => {
    const [scale, setScale] = useState(1);
    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            const height = window.innerHeight;

            // Calculate scale factor based only on height
            // Math.min with 1 prevents scaling beyond 100%
            const newScale = Math.min(height / baseHeight, 1);

            setScale(newScale);
            setViewportHeight(height);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [baseHeight]);

    return { scale, viewportHeight };
};

export default useHeightScaling;
